module.exports = __webpack_public_path__ + "static/RebeccaDickerson-f0ff0fece0673c4a39802f9d74cd1f74.png";